import styles from "./SubmitContractBtn.module.scss";

const SubmitContractBtn = ({ text, handleNextStep }) => (
  <button type="button" className={styles.previous_btn_from} onClick={handleNextStep}>
    {text}
  </button>
);

export default SubmitContractBtn;
